var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecurityBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE7E9",
    d: "M3,16 C3.55228475,16 4,16.4477153 4,17 L4,19 C4,19.5522847 3.55228475,20 3,20 C2.44771525,20 2,19.5522847 2,19 L2,17 C2,16.4477153 2.44771525,16 3,16 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE7E9",
    d: "M8,14 C8.55228475,14 9,14.4477153 9,15 L9,19 C9,19.5522847 8.55228475,20 8,20 C7.44771525,20 7,19.5522847 7,19 L7,15 C7,14.4477153 7.44771525,14 8,14 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE7E9",
    d: "M13,10 C13.5522847,10 14,10.4477153 14,11 L14,19 C14,19.5522847 13.5522847,20 13,20 C12.4477153,20 12,19.5522847 12,19 L12,11 C12,10.4477153 12.4477153,10 13,10 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE7E9",
    d: "M18,6 C18.5522847,6 19,6.44771525 19,7 L19,19 C19,19.5522847 18.5522847,20 18,20 C17.4477153,20 17,19.5522847 17,19 L17,7 C17,6.44771525 17.4477153,6 18,6 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityBars);
export default __webpack_public_path__ + "static/media/security-bars.c77d2ea82f985b774ce45c9d790b90d9.svg";
export { ForwardRef as ReactComponent };